import { UUIDPathRegex } from '@cbgms/base/utils/uuid'
import { pathCMSPromotionItem, pathCMSPromotionsList } from 'app/wholesaler/routing'
import { generatePath, matchPath } from 'react-router-dom'

export const OrderUrl = '/orders'
export const OrderDetailUrl = `/orders/:workorderUUID(${UUIDPathRegex})`
export const OrderCatalogsUrl = '/orders/catalogs'
export const OrderOpenApprovalsUrl = '/orders-open-approvals'
export const OrderQuotationsUrl = '/orders-quotations'
export const OrderQuotationDetailUrl = '/orders-quotations/:QuotationUUID'
export const OrderPromotionsListUrl = `${OrderDetailUrl}${pathCMSPromotionsList()}`
export const OrderPromotionItemUrl = `${OrderDetailUrl}${pathCMSPromotionItem()}`

export const urlOrderPromotionItem = (workorderUUID: string, wholesalerUUID: string, promotionItemID: string) =>
  generatePath(OrderPromotionItemUrl, { workorderUUID, wholesalerUUID, promotionItemID })

export const urlOrderPromotionsList = (workorderUUID: string, wholesalerUUID: string) =>
  generatePath(OrderPromotionsListUrl, { workorderUUID, wholesalerUUID })

export const isOrderPath = (url: string) => {
  return matchPath(url, { path: OrderDetailUrl, exact: false, strict: false })
}
